import formComponent from '@/util/proto/formComponent'
import { moment } from '@/util'
import { getStaticPath } from '@/util/request'
import global from '@/util/mixin/global'

export default {
  extends: formComponent ,
  mixins:[global],
  data() {
    const statusValidator = (rule, value, callback) => {
      if( value == 0){
        if( this.state.releaseDatetime ){
          callback()
        }else{
          callback(new Error('请选择发布时间'));
        }
      }else{
        callback()
      }
    }
    return {
      formData: {
        title: {
          rules:[
            { required: true, message: '请输入名称', trigger: 'blur,change' },
          ]
        },
        remark: {
          rules:[
            { required: false, message: '请输入描述', trigger: 'blur,change' },
          ]
        },
        companyId:{
          initialValue:[],
          rules:[
            { required: true, type:'array', message: '请选择适用单位', trigger: 'blur,change' },
          ]
        },
        orgId:{
          initialValue:[],
          rules:[
            { required: true, type:'array', message: '请选择监管单位', trigger: 'blur,change' },
          ]
        },
        images:{
          rules:[
            { required: false, type:'array', message: '请选择图片', trigger: 'blur,change' },
          ]
        },
        pushUserType:{
          initialValue:[],
          rules:[
            { required: true, type:'array', message: '请选择推送对象', trigger: 'blur,change' },
          ]
        },
        content:{
          rules:[
            { required: true, message: '请输入内容', trigger: 'blur,change' },
          ]
        },
        publishImmediate:{
          //initialValue:1,
          rules:[
            { required: true, type:'number',message: '请选择发布时间', trigger: 'blur,change' },
            { validator:statusValidator, trigger: 'blur,change' },
          ]
        }
      },
      state:{
        releaseDatetime:null,
        pushUserType:[],
        releaseOptions:{
          disabledDate(date){
            return date && date.valueOf() < Date.now() - 86400000;

          }
        }
      },
      loading:false,
      visible: false,
      id: null,
      isCreate: true,
      api:['noticeCreate','noticeUpdate']
    }
  },
  mounted(){
    
  },
  computed: {
    itemTitle() {
      return this.id ? '编辑公告' : '新增公告'
    }
  },

  methods: {
    init(id) {
      this.id = id
      this.visible = true
      this.reset()

      if (this.id) {
        this.query()
      }
    },
    reset(){
      this.$resetFormData()
    },
    query() {
      this.loading = true
      this.$request.notice(this.id).then(resp => {
        this.loading = false
        this.setDefault(resp.data)
      })
    },
    setDefault(d){
      d.companyId = d.objs.filter(i => (i.type == 0)).map( i => i.objId)
      d.orgId = d.objs.filter(i => i.type == 1).map( i => i.objId)

      if(d.isAllCom == 1){
        d.companyId = [0]
      }
      if(d.isAllOrg == 1){
        d.orgId = [0]
      }

      d.pushUserType = d.pushUserType.split(';').map( i => parseInt(i) )

      if( this.isCompany ){
        d.pushUserType = []
      }

      d.images = d.images ? d.images.split(';') : []
      d.publishImmediate = d.status
      if(d.releaseDatetime){
        this.state.releaseDatetime = new Date(d.releaseDatetime)
      }
      this.state.pushUserType = d.pushUserType
      this.$setFormData(d , false, true)
    },

    beforeSave(d){
      if( this.isCompany ){
        d.companyId = [this.subjectId]
        d.orgId = []
        d.pushUserType = [6]
      }

      const params = { ...d }

      const pushUserType = d.pushUserType;
      const subject = [[4,'orgId',1],[5,'companyId',0],[6,'companyId',0]].reduce((t,c) => {
        let r = []
        if(pushUserType.includes(c[0]) && d[c[1]] && !d[c[1]].includes(0)){
          r = d[c[1]].map( i => ({ "objId": i, "type": c[2] }))
        }
        return t.concat( r )
      },[])
      

      delete params.companyId
      delete params.orgId
      delete params.publishImmediate

      params.isAllCom = d.companyId && d.companyId.includes(0) ? 1 : 0
      params.isAllOrg = d.orgId && d.orgId.includes(0) ? 1 : 0
      
      params.objs = subject

      if(d.publishImmediate == 0){
        params.releaseDatetime = this.state.releaseDatetime
      }
      console.log(params)

      if(Array.isArray(d.images)){
        params.images = d.images.join(';')
      }

      if(Array.isArray(d.pushUserType)){
        params.pushUserType = d.pushUserType.join(';')
      }

      if(this.id){
        params.id = this.id
      }
      return params
    },
    handleChangeSubject(v){
      this.state.pushUserType = [...v]
    },
    handleChangePublishDate(){
      this.$nextTick(()=>{
        this.form.validateFields(['publishImmediate'])
      })
    }
  },
  render(){
    const { itemTitle , formData , loading , state } = this


    // TODO 推送主体 需等待 pushUserType 更新 后插入，导致 后续的decorator 无法被赋值
    // setFieldsValue --> pushUserType change --> subject id insert 
    // 
    // let pushUserType = this.form ? this.form.getFieldValue('pushUserType') : null

    let pushUserType = state.pushUserType || []

    let publishImmediate = this.form ? this.form.getFieldValue('publishImmediate') : null

    let extra = []
    let pushUserOptions = this.isAS ? [[4,'监管人员'],[5,'网点人员'],[6,'快递人员']] : [[6,'快递人员']]

    if( this.isAS ){
      extra.push(
        <sl-form-item label="推送对象">
          <CheckboxGroup v-decorator={formData.pushUserType} on-on-change={this.handleChangeSubject} >
            {
              pushUserOptions.map(i => (
                <Checkbox label={i[0]}>{i[1]}</Checkbox>
              ))
            }
          </CheckboxGroup>
        </sl-form-item>
      )
    }
    if(pushUserType.includes(5) || pushUserType.includes(6)){
      extra.push(
        <sl-form-item label="推送企业">
          <sl-select before={[{value:0 , label:'所有企业'}]} multiple={true} dict="company" filterable={true} v-decorator={formData.companyId} />
        </sl-form-item>
      )
    }
    if(pushUserType.includes(4)){
      extra.push(
        <sl-form-item label="推送监管">
          <sl-select before={[{value:0 , label:'所有监管'}]} multiple={true} dict="org" filterable={true} v-decorator={formData.orgId} />
        </sl-form-item>
      )
    }

    return (
        <sl-side-panel v-model={this.visible} loading={loading} mask-closable={false} title={itemTitle}>
          <sl-form label-width={100}>
            <sl-form-item label="公告标题">
              <Input v-decorator={formData.title} placeholder="标题限20字" maxlength={20} ></Input>
            </sl-form-item>
            <sl-form-item label="公告内容">
              <Input type="textarea" placeholder="内容限500字" maxlength={500} autosize={{minRows: 5,maxRows: 8}} v-decorator={formData.content}></Input>
            </sl-form-item>
            <sl-form-item label="公告图片">
              <sl-upload public={true} style="margin-top:8px;" v-decorator={formData.images} type="16" limit={9}>支持格式：jpg, png, bmp , gif。最多9张。</sl-upload>
            </sl-form-item>
            {  extra }
            <sl-form-item label="发布时间">
               <RadioGroup v-decorator={formData.publishImmediate}>
                <Radio label={1}>
                  <span>立即发布</span>
                </Radio>
                <Radio label={0}>
                  <span>指定时间</span>
                </Radio>
              </RadioGroup>
              <DatePicker v-show={publishImmediate==0} type="datetime" placement="bottom-end" options={state.releaseOptions} placeholder="请选择指定时间" v-model={state.releaseDatetime} on-on-clear={this.handleChangePublishDate} on-on-open-change={v => !v && this.handleChangePublishDate()} ></DatePicker>
            </sl-form-item>
            <sl-form-item label="备注">
              <Input type="textarea" autosize={{minRows: 3,maxRows: 5}} v-decorator={formData.remark}></Input>
            </sl-form-item>
          </sl-form>
          <div slot="footer">
            <Button loading={loading} on-click={this.$handleSubmit} type="primary">确定</Button>
          </div>
      </sl-side-panel>
    )
  }
}

export const View = {
  data() {
    return {
      loading: false,
      data: {},
      visible: false,
    }
  },
  props:['id'],
  created(){
    this.$watch('id' , function(nv){
      if(nv) this.query()
    },{immediate:true})
  },
  methods: {

/*    init(id ) {
      this.id = id
      this.visible = true
      if (this.id) {
        this.query()
      }
    },
*/
    query() {
      this.loading = true
      this.$request.notice(this.id).then( resp => {
        this.loading = false
        if(resp.code == 0){
          this.setDefault(resp.data)
        }else{
          //this.visible = false
          this.$Message.error({ content: resp.msg })
        }
      })
    },

    setDefault(d){
      d.publishDate = moment(d.releaseDatetime , 'yyyy-MM-dd')
      this.data = d
    },

    renderImage(){
      if( this.data.images ){
        let img = this.data.images.split(';').map(getStaticPath)
        return  <Carousel loop>
          { 
            img.map( i => {
              let style = {
                width:'100%',
                height:'280px',
                background:`url(${i}) center center / contain no-repeat`
              }
              return <CarouselItem>
                <div style={style}></div>
              </CarouselItem>
            })
          }
        </Carousel>
      }else{
        return null
      }
    }
  },
  render(){
    const { loading , data , renderImage } = this
    // const content = data.content.split()

    return (
      <sl-spin loading={loading}>
        <div style="min-height:600px;">
          <div class="modal-body">
            <div style="font-size:16px;color:rgba(0,0,0,.75);text-align:center;    line-height: 1.4;margin: 16px 0;">{data.title}</div>
            <div style="font-size:12px;margin:8px 0 16px 0;text-align:center; color: rgba(0,0,0,0.45);">
              <span style="margin-right:8px;">{data.pubName}</span>
              <span>{data.publishDate}</span>
            </div>
            <div style="margin-top:8px;font-size:13px;color:rgba(0,0,0,.65);line-height:1.8em;">
              {renderImage()}
              <div style="margin-top:16px;">{data.content}</div>
            </div>
          </div>
        </div>
      </sl-spin>
    )
  }
}